const LinkMarker = {
    name: 'LinkMarker',
    data() {
        return {
            options: null,
            active: false,
        }
    },
    props: ['entity', 'identifier'],
    emits: ['updated'],
    methods: {
        linkMarker() {
            // http request to the server with the data and the
        },
        markerListener(data) {
            let marker = data.detail;

            axios.post('/risk/marker', {
                'id': this.identifier,
                'entity': this.entity,
                'marker': marker?.attributes,
            }).then(response => {

                this.$emit('updated', response.data.marker)
            });

            this.active = false;

        },
        listener(e) {
            this.active = true;
            document.addEventListener('cm_markup_session_updated', this.markerListener, {
                once: true
            })
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.$el?.addEventListener('click', this.listener)
        })
    },

    render() {

        return this.$scopedSlots.default({
            active: this.active
        });
    }
}

export default LinkMarker;
